export const URL_QUERY_PARAM_BRIDGE_KEY = 'xpb';
export const URL_QUERY_PARAM_ID_KEY = 'xpid';
export const URL_QUERY_PARAM_SOURCE_KEY = 'xps';

export const generateUrlWithParams = (
	url: string,
	bridge: string,
	interactionSessionId: string,
	interactionSource: string,
	subProduct?: string,
) => {
	let completeInteractionSource: string;

	const urlObj = new URL(url);
	urlObj.searchParams.set(URL_QUERY_PARAM_BRIDGE_KEY, bridge);
	urlObj.searchParams.set(URL_QUERY_PARAM_ID_KEY, interactionSessionId);

	completeInteractionSource = subProduct ? `${interactionSource}.${subProduct}` : interactionSource;
	urlObj.searchParams.set(URL_QUERY_PARAM_SOURCE_KEY, completeInteractionSource);

	return urlObj.toString();
};
